import { render, staticRenderFns } from "./BufferTutorDetail.vue?vue&type=template&id=4187b28e&scoped=true"
import script from "./BufferTutorDetail.vue?vue&type=script&lang=js"
export * from "./BufferTutorDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4187b28e",
  null
  
)

export default component.exports